import { TabConfig } from '~/ui/components'

const tabConfigs: TabConfig[] = [
  {
    label: 'PRINCIPAL',
    value: 'main',
    disabled: false,
  },
  {
    label: 'SERVICIOS',
    value: 'services',
    disabled: false,
  },
  // {
  //   label: 'DETALLES DE USO',
  //   value: 'usage',
  //   disabled: false,
  // },
  // {
  //   label: 'REGISTRO',
  //   value: 'historic',
  //   disabled: false,
  // },
]

export default tabConfigs
